import { render, staticRenderFns } from "./LoginSelectRole.vue?vue&type=template&id=1c331d92&"
import script from "./LoginSelectRole.vue?vue&type=script&lang=js&"
export * from "./LoginSelectRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports